<div class="h-full min-h-0 overflow-y-auto scrollbar-transparent">
  @if (loadingState() === 'loading') {
    <p class="text-sm text-secondary m-0 p-4">Loading media kit settings…</p>
  } @else if (loadingState() === 'error') {
    <p class="text-sm text-red-600 m-0 p-4" role="alert">Failed to load media kit config.</p>
  } @else if (mediaKitConfig()) {
    <div class="flex flex-col gap-3 p-2">
      @for (row of [
        { field: 'show_bio', label: 'Bio', desc: 'Show creator bio on media kit', selected: selectedBioOption() },
        { field: 'show_age', label: 'Age', desc: 'Show creator age on media kit', selected: selectedAgeOption() },
        { field: 'show_address', label: 'Address', desc: 'Show creator address on media kit', selected: selectedAddressOption() },
        { field: 'show_interests', label: 'Interests', desc: 'Show creator interests on media kit', selected: selectedInterestsOption() },
        { field: 'show_reviews', label: 'Reviews', desc: 'Show creator reviews on media kit', selected: selectedReviewsOption() },
        { field: 'show_videos', label: 'Videos', desc: 'Show creator videos on media kit', selected: selectedVideosOption() },
        { field: 'show_stats', label: 'Stats', desc: 'Show creator stats on media kit', selected: selectedStatsOption() }
      ]; track row.field) {
        <div class="flex items-center justify-between gap-4 rounded-xl border border-zinc-200 bg-white p-4 dark:border-zinc-800 dark:bg-zinc-950">
          <div>
            <h4 class="text-sm font-semibold text-primary m-0">{{ row.label }}</h4>
            <p class="text-xs text-secondary m-0 mt-1">{{ row.desc }}</p>
          </div>
          <app-toggle
            [options]="showHideOptions"
            [selectedOption]="row.selected"
            (selectedOptionChange)="onToggle($any(row.field), $event)" />
        </div>
      }

      @if (selectedStatsOption().value) {
        <div class="grid grid-cols-1 gap-3 lg:grid-cols-3">
          @for (row of [
            { field: 'show_stats_instagram', label: 'Instagram stats', selected: selectedStatsInstagramOption() },
            { field: 'show_stats_tiktok', label: 'TikTok stats', selected: selectedStatsTiktokOption() },
            { field: 'show_stats_youtube', label: 'YouTube stats', selected: selectedStatsYoutubeOption() }
          ]; track row.field) {
            <div class="flex items-center justify-between gap-3 rounded-xl border border-zinc-200 bg-white p-4 dark:border-zinc-800 dark:bg-zinc-950">
              <p class="text-sm font-medium text-primary m-0">{{ row.label }}</p>
              <app-toggle
                [options]="showHideOptions"
                [selectedOption]="row.selected"
                (selectedOptionChange)="onToggle($any(row.field), $event)" />
            </div>
          }
        </div>
      }
    </div>
  }
</div>
